import { GetGenerateSasTokenPayloadType } from "../../../../commonTypes/stcoToolsType";
import { HRMS_BULK_UPLOAD_LIST_HEADERS } from "../../../../constant/tableHeadersConstants/allBulkUploadReportConst";
import { TableHeader } from "../../../commons";
import InfiniteLoader from "../../../commons/InfiniteLoader/InfiniteLoader";
import ScrollToTop from "../../../commons/ScrollToTop";
import HRMSBulkUploadTableData from "./HRMSBulkUploadTableData";

type AppProps = {
  fetching: boolean;
  token: string | null;
  offset: number;
  data: any[] | [];
  sasTokenForDownloadFile: string;
  dispatchResetSasTokenForDownloadFile: () => void;
  dispatchGetTokenGenerateForDownloadAction: (
    data: GetGenerateSasTokenPayloadType
  ) => void;
};

const HRMSBulkUploadTable = ({
  fetching,
  offset,
  data,
  sasTokenForDownloadFile,
  dispatchResetSasTokenForDownloadFile,
  dispatchGetTokenGenerateForDownloadAction,
  token,
}: AppProps) => {
  return (
    <div className="jobsType" style={{ overflowX: "scroll" }}>
      <table className="table thead-light table-bordered">
        <thead className="text-start sticky-table-header">
          <TableHeader tableHeader={HRMS_BULK_UPLOAD_LIST_HEADERS} />
        </thead>
        <tbody>
          <HRMSBulkUploadTableData
            data={data}
            tableHeader={HRMS_BULK_UPLOAD_LIST_HEADERS}
            token={token}
            sasTokenForDownloadFile={sasTokenForDownloadFile}
            dispatchResetSasTokenForDownloadFile={
              dispatchResetSasTokenForDownloadFile
            }
            dispatchGetTokenGenerateForDownloadAction={
              dispatchGetTokenGenerateForDownloadAction
            }
          />
          {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
          <div style={{ display: fetching ? "none" : "inline" }}>
            <ScrollToTop />
          </div>
        </tbody>
      </table>
    </div>
  );
};

export default HRMSBulkUploadTable;
